export const routeNames = [
  "Default",
  "Signin",
  "MyAccount",
  "Note",
  "Notebooks",
  "Route404",
];
